import { environment } from '@environment';
import { ThemesEnum } from '@shared/enums';
import { ThemeService } from '@shared/ui';
import { Subject, takeUntil } from 'rxjs';

import {
  Component,
  HostBinding,
  OnDestroy,
  computed,
  inject,
} from '@angular/core';
import {
  ActivationStart,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';

import { CommandMenuComponent } from './shared/ui/components/command-menu/command-menu.component';
import { AuthService } from './shared/ui/services/auth/auth.service';

type GtagFunction = (
  command: string,
  targetId: string,
  parameters: { page_path: string }
) => void;

declare let gtag: GtagFunction;

@Component({
  standalone: true,
  imports: [RouterModule, CommandMenuComponent],
  selector: 'phoenix-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy {
  @HostBinding('class.dark') get mode() {
    return this.darkMode();
  }
  destroy$ = new Subject<void>();
  private readonly authService = inject(AuthService);
  private readonly theme = inject(ThemeService);
  darkMode = computed<boolean>(() => {
    return this.theme.themeSignal() === ThemesEnum.DARK;
  });

  constructor(readonly router: Router) {
    // Send basic page view to GA
    const gtagId = environment.gtagId;
    if (Array.isArray(gtagId)) {
      this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
        if (event instanceof NavigationEnd) {
          //Send user info to GA custom dimensions
          const user = this.authService.currentUser();
          if (user) {
            gtag('set', 'user_properties', {
              user_q6client: user.email, // email
              q6_user_id: user.uid, // ID
              q6_user_username: user.displayName, // username
            } as any);
          }
          gtagId.forEach(gid => {
            gtag('config', gid, {
              page_path: event.urlAfterRedirects.split('?')[0],
              page_location: location.href.split('?')[0],
            } as any);
          });
        }
      });
    }

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event instanceof ActivationStart) {
        const featureFlag = event.snapshot.data['featureFlag'];
        featureFlag
          ? localStorage.setItem('activeFeatureFlag', featureFlag)
          : localStorage.removeItem('activeFeatureFlag');
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
